import styled from 'styled-components'

const Content = styled.span`
  display: flex;
  align-items: center;
  margin: 0 10px;
`

const InlineField = ({ children }) => <Content>{children}</Content>

export default InlineField
